import type React from "react";

import { useEffect } from "react";
import { useNavigate } from "react-router";
import { routes } from "routes/routes";

export const Homepage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    void navigate(routes.requests.main, { replace: true });
  }, [navigate]);

  return null;
};
